import { useQuery } from '@tanstack/react-query';
import { getAutomationLimit } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';

/** 무한리필 이벤트 활성 여부 (studio limit.refillEventActive). useAutomationLimit 과 캐시 공유. */
export const useAutomationPassEvent = () =>
    useQuery({
        queryKey: queryKeys.dmAutomation.limit(),
        queryFn: getAutomationLimit,
        staleTime: 5 * 60 * 1000,
        select: (limit) => limit?.refillEventActive === true,
    });
